commusoftCommon.directive('reportingOperationalList', ['prefix', '$http', '$modal', 'tableCollection', '$document', '$timeout', 'clickEvents', '$rootScope', '$compile', 'dragHelper', '$state', function(prefix, $http, $modal, tableCollection, $document, $timeout, clickEvents, $rootScope, $compile, dragHelper, $state) {
    return {
        restrict: 'ACE',
        controller: 'ReportingOperationalListViewCtrl'
    }
}]);